import sectionColorsConfig from '../config/section-colors.json';
export function sectionStyle(color) {
    const bg = color || sectionColorsConfig.default;
    const found = sectionColorsConfig.palette.find((p) => p.bg.toLowerCase() === bg.toLowerCase());
    if (found)
        return found;
    return sectionColorsConfig.palette[0] ?? { bg, text: '#166534', border: '#BBF7D0' };
}
export function sectionPalette() {
    return sectionColorsConfig.palette;
}
export const SECTION_COLOR_DEFAULT = sectionColorsConfig.default;
